module.exports = __webpack_public_path__ + "img/closeicon.4cf41cda.svg";